import { SessionStorageService } from './session.storage.service';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  BehaviorSubject } from 'rxjs';
import * as AWS from 'aws-sdk/global';


import {
	CognitoUserPool,
	CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession
} from 'amazon-cognito-identity-js';

import {ApiUserService} from "./api/api-user.service";

const POOL_DATA = {
	UserPoolId:environment.AwsUserPoolId, // Your user pool id here
	ClientId: environment.AwsClientId, // Your client id here
};
const userPool = new CognitoUserPool(POOL_DATA);

import { UserModel } from '../models/user.model';
import {Profile} from '../models/profile.model';
import { Signup } from "../../feature/public/signup/signup.model";
import {UserModule} from "../../feature/user/user.module";
import { constants } from 'os';


@Injectable()
export class AuthService {
  authIsLoading = new BehaviorSubject<boolean>(false);
  authMessage = new BehaviorSubject<string>('');
  forgotIsLoading = new BehaviorSubject<boolean>(false);
  authDidFail = new BehaviorSubject<boolean>(false);
  isRegistered = new BehaviorSubject<any>(false)
  isPhoneVerify = new BehaviorSubject<boolean>(false)
  isEnableMFA  = new BehaviorSubject<boolean>(false)
  authStatusChanged = new Subject<boolean>();
  registeredUser: CognitoUser
  userLogged = new Subject<object>();
  constructor(
    private router: Router,
    private apiService:ApiUserService,
    private sessionStorageService:SessionStorageService
    ) {}

  signUp(username: string, email: string, password: string,profile:Profile): void {
    this.authIsLoading.next(true);
    const user = new UserModel();
    user.email = email
    user.password = password
    const pro:Profile = profile


    const attrList: CognitoUserAttribute[] = [];
    const emailAttribute = {
      Name: 'email',
      Value: user.email
    };
    attrList.push(new CognitoUserAttribute(emailAttribute))
    for(let key in pro) {
      var value = pro[key];
      var name = key;
      if(key === 'timezone' || key === 'language'){
        name ="custom:"+key
      }
      const attribute = {
        Name: name,
        Value: value
      };
      attrList.push(new CognitoUserAttribute(attribute))
    }

    console.log(attrList)

    userPool.signUp(user.email, user.password,attrList,null,(err,result) => {
      if (err) {
        this.authMessage.next(err.message)
        this.authDidFail.next(true)
        this.authIsLoading.next(false)
        return
      }
      this.authDidFail.next(false)
      this.authIsLoading.next(false)
      this.isRegistered.next(result)
      this.registeredUser = result.user
      // const signup = new Signup()
      // signup.first_name = pro.name
      // signup.last_name = pro.family_name
      // signup.email = user.email
      // this.apiService.signUp(signup).subscribe(res=>{
      //   console.log(res)
      //   if(res.status === "ERROR"){
      //     alert(res.message)
      //   }else{
      //     this.router.navigate([''])
      //   }
      // })
    })

    return;
  }
  async confirmRegistration(email,profile,code){
    return new Promise((resolve,reject)=>{
      const userData={
        Username: email,
        Pool: userPool
      }
      const pro:Profile = profile
      const cognitoUser = new CognitoUser(userData)
      cognitoUser.confirmRegistration(code, true, (err, result)=> {
        if (err) {
          resolve(err.message || JSON.stringify(err));
          return;
        }
        console.log('call result: ' + result);
        const signup = new Signup()
        signup.first_name = pro.name
        signup.last_name = pro.family_name
        signup.email = email
        this.apiService.signUp(signup).subscribe(res=>{
          if(res.status === "ERROR"){
            resolve(res.message)
          }else{
            resolve('success')
            this.router.navigate([''])
          }
        })
      });
    })
  }


  async resendConfirmRegistration(email){
    return new Promise((resolve,reject)=>{
      const userData={
        Username: email,
        Pool: userPool
      }
      const cognitoUser = new CognitoUser(userData)
      cognitoUser.resendConfirmationCode((err, result)=> {
        if (err) {
          resolve(err.message || JSON.stringify(err));
          return;
        }
        console.log('call result: ' + result);
        resolve('success')
      });
    })
  }

  refreshToken(force=0){
    const cognitoUser = this.getAuthenticatedUser();
    
    cognitoUser.getSession((err, session) => {

      const refresh_token = session.getRefreshToken(); // receive session from calling cognitoUser.getSession()
        
      AWS.config.region = environment.AwsRegion;
      const user_pool_key = 'cognito-idp.'+environment.AwsRegion+'.amazonaws.com/'+environment.AwsUserPoolId
      console.log(session)
      const login = {}
      login[user_pool_key]=session.getIdToken().getJwtToken();

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.AwsIdentifyPoolId, // your identity pool id here
        Logins: login,
      });

      if (session.isValid() === false || force==1) {
        cognitoUser.refreshSession(refresh_token, (err, session_new) => {
          if (err) {
            console.log(err);
          } else {
            (AWS.config.credentials as AWS.CognitoIdentityCredentials).params['Logins'][user_pool_key] = session_new.getIdToken().getJwtToken();
            (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(err => {
              if (err) {
                console.log(err);
              } else {
                // Token
                console.log('token refresh')
                const logged = this.sessionStorageService.getLoggedUser();
                logged.token = session_new.getAccessToken().getJwtToken()
                this.sessionStorageService.set("logged",logged)
                
                this.apiService.updateToken({
                  email:session_new.getIdToken().payload.email,
                  refresh_token:session_new.getRefreshToken().getToken(),
                  access_token:session_new.getAccessToken().getJwtToken(),
                }).subscribe(res=>{
                  if(res.status==="ERROR"){
                    console.log(res.message)
                  }
                })

              }
            });
          }
        });
      }

    })

  }

  signIn(username: string, password: string): void {
    this.authIsLoading.next(true);
    const authData = {
      Username: username,
      Password: password
    };
    const authDetails = new AuthenticationDetails(authData)
    const userData={
      Username: username,
      Pool: userPool
    }
    const cognitUser = new CognitoUser(userData)
    const that = this
    console.log('signin')
    cognitUser.authenticateUser(authDetails,{
      onSuccess(result: CognitoUserSession) {

    console.log('success')
      // const accessToken = result.getAccessToken().getJwtToken();
      //POTENTIAL: Region needs to be set if not already set previously elsewhere.
      AWS.config.region = environment.AwsRegion;
      const user_pool_key = 'cognito-idp.'+environment.AwsRegion+'.amazonaws.com/'+environment.AwsUserPoolId
      
      const login = {}
      login[user_pool_key]=result.getIdToken().getJwtToken();

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.AwsIdentifyPoolId, // your identity pool id here
        Logins: login,
      });
      
      //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
      (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(error => {
        if (error) {
          console.error(error);
        } else {
          that.apiService.logIn({
            email:result.getIdToken().payload.email,
            id_token:result.getIdToken().getJwtToken(),
            refresh_token:result.getRefreshToken().getToken(),
            access_token:result.getAccessToken().getJwtToken(),
          }).subscribe(res=>{
            if(res.status==="ERROR"){
              console.log(res.message)
              that.authStatusChanged.next(false)
              that.authDidFail.next(true)
              that.authIsLoading.next(false)
            }else{

              that.sessionStorageService.set('logged',res.data)

              that.sessionStorageService.set('login_credential',JSON.stringify(login))
              that.authStatusChanged.next(true)
              that.authDidFail.next(false)
              that.authIsLoading.next(false)
            }
          })
        }
      }); 

      },
      onFailure(err){
        that.authStatusChanged.next(false)
        that.authDidFail.next(true)
        that.authIsLoading.next(false)
      },
      newPasswordRequired: function(userAttributes, requiredAttributes) {
        delete userAttributes.email_verified;
        delete userAttributes.phone_number_verified;
        cognitUser.completeNewPasswordChallenge(password, userAttributes, this);
      },

      mfaRequired:function () {
        const verificationCode = prompt('Please input verification code', '');
        cognitUser.sendMFACode(verificationCode, this);
      }
    })

    // this.authStatusChanged.next(true);
    return;
  }
  getAuthenticatedUser() {
    return userPool.getCurrentUser()
  }
  logout() {
    const cogUser = this.getAuthenticatedUser()
    if(cogUser){
      cogUser.signOut()
    }
    this.authStatusChanged.next(false);
  }

  getUserAttribute(){
    const cognitoUser = this.getAuthenticatedUser();

    cognitoUser.getSession((err, session) => {

      cognitoUser.getUserAttributes((err, result) =>{
        if (err) {
          // Handle error
          console.log(err)
        } else {
          let object = {};
          for (let i = 0; i < result.length; i++) {
            object[result[i].getName()]= result[i].getValue()
          }
          this.userLogged.next(object)
        }
      });
    })
  }

  getUserMFA(){

    this.authIsLoading.next(true)
    const cognitoUser = this.getAuthenticatedUser();
    cognitoUser.getSession((err, session)=> {
      cognitoUser.getMFAOptions( (err, mfaOptions) =>{
        this.authIsLoading.next(false)
        if (err) {
          alert(err.message || JSON.stringify(err));
          return;
        }
        if(mfaOptions && mfaOptions.length > 0 ){
          this.isEnableMFA.next(true)
        }else {
          this.isEnableMFA.next(false)
        }

      });
    })
  }
  onEnableMFA(){
    this.authIsLoading.next(true)
    const cognitoUser = this.getAuthenticatedUser();
    cognitoUser.getSession((err, session)=>{
      cognitoUser.enableMFA((err, result) =>{
        if (err) {
          alert(err.message || JSON.stringify(err));
          return;
        }
        this.isEnableMFA.next(true)
        this.authIsLoading.next(false)
      });
    })
    return;
  }
  onDisableMFA(){
    this.authIsLoading.next(true)
    const cognitoUser = this.getAuthenticatedUser();
    cognitoUser.getSession((err, session)=>{
      cognitoUser.disableMFA((err, result) =>{
        if (err) {
          alert(err.message || JSON.stringify(err));
          return;
        }
        this.isEnableMFA.next(false)
        this.authIsLoading.next(false)
      });
    })
    return;
  }
  isAuthenticated(): Observable<boolean> {
    const user = this.getAuthenticatedUser();
    const obs = new Observable<boolean>((observer) => {
      if (! user) {
        observer.next(false);
      } else {
        user.getSession((err, session) => {
          if(err) {
            console.log('error session 1')
            observer.next(false);
          }else{

            if(session.isValid()){
              // this.apiService.checkValidToken(session.getAccessToken().getJwtToken()).subscribe(res=>{
              //   if(res.status==="ERROR"){
              //     console.log('session invalid')
              //     observer.next(false);
              //   }else{
                  console.log('session valid')
                  observer.next(true);
                // }
              // })

            }else{

              console.log('error session 2')
              observer.next(false);
            }
          }
        })
      }
      observer.complete();
    });
    return obs;
  }


  verifyPhoneNumber(phone){
    const cognitoUser = this.getAuthenticatedUser();
    this.authIsLoading.next(true)
    cognitoUser.getSession((err, session)=>{
      // @ts-ignore

      let attributeList = [];

      let attribute = {
        Name: "phone_number",
        Value:  phone
      };
      let attribute_obj = new CognitoUserAttribute(attribute);
      attributeList.push(attribute_obj);

      cognitoUser.updateAttributes(attributeList, (err, result)=> {
        if (err) {
          alert(err.message || JSON.stringify(err));
          return;
        }

        const that=this;
        cognitoUser.getAttributeVerificationCode('phone_number', {
          onSuccess: function () {
            that.authIsLoading.next(false)
            that.isPhoneVerify.next(true)
            console.log('success')
          },
          onFailure: function (er) {
            that.isPhoneVerify.next(false)
            that.authIsLoading.next(false)
            console.log('erroe')
            alert(er.message || JSON.stringify(er));
          },
          inputVerificationCode: function () {
            that.isPhoneVerify.next(false)

            that.authIsLoading.next(false)
            var verificationCode = prompt('Please input verification code: ', '');
            cognitoUser.verifyAttribute('phone_number', verificationCode, this);
          }
        });
      });
    });
  }

  forgotPassword(email: string) {
    this.authIsLoading.next(true);
    const userData = {
      Username: email,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData)
    const that= this
    cognitoUser.forgotPassword({
      onSuccess: function(data) {
        that.authStatusChanged.next(false);
        that.forgotIsLoading.next(true);
        that.authIsLoading.next(false)
        // successfully initiated reset password request
        // console.log('CodeDeliveryData from forgotPassword: ' + JSON.stringify(data));
      },
      onFailure: function(err) {
        that.authIsLoading.next(false)
        that.authStatusChanged.next(false);
        that.forgotIsLoading.next(false);
        alert(err.message || JSON.stringify(err));
      }
    });
  }

  changeNewPassword(email: string,code:string,password:string){
    const userData = {
      Username: email,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData);
    const that = this;
    cognitoUser.confirmPassword(code, password, {
      onSuccess() {
        alert('Password confirmed!');
        window.location.reload();
      },
      onFailure(err) {
        alert(err.message || JSON.stringify(err))
      },
    });
  }
  initAuth() {
    this.isAuthenticated().subscribe(
      (auth) => this.authStatusChanged.next(auth)
    );
  }

}
